module.exports = __webpack_public_path__ + "img/kuang.59a84a75.png";